import { render, staticRenderFns } from "./HeaderSearchResults.vue?vue&type=template&id=3ac0ced4&scoped=true&"
import script from "./HeaderSearchResults.vue?vue&type=script&lang=js&"
export * from "./HeaderSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSearchResults.vue?vue&type=style&index=0&id=3ac0ced4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac0ced4",
  null
  
)

export default component.exports